module.exports = __webpack_public_path__ + "fonts/Geometria-Medium.woff?45656b73e1a07f979bfb56559b359b07";